/*
  FluoFree — ff-glas-scroll

  Eén voortgangswaarde p (0..1) over de hoogte van de sectie stuurt alles:
  video.currentTime, de kop, vijf uittypende stappen, de TDS-badge en de knop. De ScrollTrigger scrubt een proxy-tween met 0,5 s naijl; de
  tween-waarde is dus al afgevlakt en render() leest alleen die.

  Laadt na gsap.min.js en ScrollTrigger.min.js (beide defer, zelfde volgorde).
  Ontbreekt GSAP, dan blijft de sectie in de rustige stand staan.
*/
(function () {
  'use strict';

  /* Fasegrenzen, gemeten op de glasvideo (15,04 s):
       0–27%   vervuild water, zwevende deeltjes
       30–55%  omslag: deeltjes verdwijnen, bellen stijgen (helft weg rond 43%)
       55–66%  helder water met bellen
       66–93%  mineralen (gekleurde bolletjes) en waterstofbellen
       93–100% ingebrande labels (Ca2+, Mg2+, K+, H2)
     Stap 1-2 in het vervuilde deel, stap 3 op de omslag, stap 4-5 in de
     mineralenfase; de knop komt tegelijk met de labels. */
  var STAP_BEGIN = [0.03, 0.15, 0.37, 0.68, 0.80];
  var TYPEN = 0.12;         // uittypen duurt 0.12 voortgang
  var KOP_MID = 0.3;        // < 0.3 start, 0.3–0.93 mid, > 0.93 slot
  var KOP_END = 0.93;
  var TDS_EINDE = 0.8;      // TDS loopt van start naar slot over 0..0.8
  var CTA_VAN = 0.93;       // knop 0 → 1 tussen 0.93 en 1
  var MOBIEL = '(max-width: 767px)';
  // Alleen mobiel: het beeld schuift van 50% naar 80% (object-position) tussen
  // 0.80 en 0.93, zodat Mg2+, K+ en H2 in beeld staan als de labels verschijnen.
  // Een vaste 80–85% kost contrast in het vervuilde deel.
  var PAN_VAN = 0.80;
  var PAN_TOT = 0.93;
  var PAN_X = 80;

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function init(root) {
    if (root.dataset.ffGlasInit === '1') return;
    root.dataset.ffGlasInit = '1';

    var video = root.querySelector('.ff-glas__video');
    var heeftEindposter = !!root.querySelector('.ff-glas__poster-end');
    var koppen = Array.prototype.slice.call(root.querySelectorAll('.ff-glas__kop > [data-kop]'));
    var cta = root.querySelector('.ff-glas__cta');
    var tdsEl = root.querySelector('[data-tds]');
    var tdsStart = parseFloat(root.dataset.tdsStart) || 0;
    var tdsEind = parseFloat(root.dataset.tdsEnd) || 0;

    var stappen = Array.prototype.slice.call(root.querySelectorAll('.ff-glas__stap')).map(function (el) {
      var delen = Array.prototype.slice.call(el.querySelectorAll('.ff-glas__typwrap')).map(function (w) {
        var rest = w.querySelector('.ff-glas__rest');
        var getypt = document.createTextNode('');
        rest.parentNode.insertBefore(getypt, rest);
        return { vol: w.querySelector('.ff-glas__vol').textContent.trim(), getypt: getypt, rest: rest };
      });
      var totaal = delen.reduce(function (n, d) { return n + d.vol.length; }, 0);
      return { el: el, delen: delen, totaal: totaal, n: -1, zichtbaar: null, typend: null };
    });

    var staat = { p: 0, kop: null, tds: null, cta: null, pan: null, rustig: false };
    var mobielMq = window.matchMedia ? window.matchMedia(MOBIEL) : null;

    /* ---------- video ---------- */
    var duur = 0, bezig = false, wachtend = null, seekSinds = 0;

    function zoek(t) {
      if (!video || !duur) return;
      // Net vóór het einde blijven: op exact duration vuurt 'ended' en toont
      // Safari soms een zwart frame.
      t = clamp(t, 0, Math.max(0, duur - 0.04));
      // Vangnet: vuurt 'seeked' niet binnen 1 s, dan niet eeuwig blijven wachten.
      if (bezig && performance.now() - seekSinds < 1000) { wachtend = t; return; }
      if (Math.abs(video.currentTime - t) < 1 / 90) return;
      bezig = true;
      seekSinds = performance.now();
      video.currentTime = t;
    }

    if (video) {
      // De bron staat als <source media=…> in de markup; de browser kiest
      // vóór de eerste byte. Hier wordt niets meer aan src gezet.

      // Eén seek tegelijk: tijdens een lopende seek onthouden we alleen het
      // laatste doel. Anders stapelt Safari seeks op en loopt het beeld achter.
      video.addEventListener('seeked', function () {
        bezig = false;
        if (wachtend !== null) { var t = wachtend; wachtend = null; zoek(t); }
      });
      var metadata = function () {
        duur = video.duration || 0;
        if (staat.rustig) { toonRustig(); } else { zoek(staat.p * duur); }
      };
      if (video.readyState >= 1) metadata();
      else video.addEventListener('loadedmetadata', metadata, { once: true });

      // Laden pas na de eerste scroll, en dan pas als de sectie binnen 1,5 scherm
      // komt. Een mp4 van 6–11 MB die tijdens het laden van de pagina start, telt
      // Lighthouse mee in de gesimuleerde FCP/LCP (mobiel 67 → 50 gemeten).
      var gestart = false;
      var bufferen = function () {
        if (gestart || (staat.rustig && heeftEindposter)) return;
        gestart = true;
        video.preload = 'auto';
        if (video.readyState === 0) video.load();
        // iOS seekt pas betrouwbaar nadat de video één keer gespeeld heeft. Gedempt
        // en inline mag dat zonder gebaar. Niet meer op de eerste touchstart: dat
        // zou de video al laden bij een tik bovenaan de pagina.
        if (navigator.maxTouchPoints > 0) {
          var pr = video.play();
          if (pr && pr.then) {
            pr.then(function () { video.pause(); bezig = false; zoek(staat.p * duur); }).catch(function () {});
          }
        }
      };
      window.addEventListener('scroll', function () {
        if (!('IntersectionObserver' in window)) { bufferen(); return; }
        var io = new IntersectionObserver(function (items) {
          if (items.some(function (i) { return i.isIntersecting; })) { io.disconnect(); bufferen(); }
        }, { rootMargin: '150% 0px' });
        io.observe(root);
      }, { once: true, passive: true });
    }

    /* ---------- tekst ---------- */
    function zetStap(s, lokaal, zichtbaar) {
      var n = Math.round(lokaal * s.totaal);
      if (n !== s.n) {
        s.n = n;
        var over = n, cursorGezet = false;
        s.delen.forEach(function (d) {
          var k = clamp(over, 0, d.vol.length);
          d.getypt.nodeValue = d.vol.substring(0, k);
          d.rest.textContent = d.vol.substring(k);
          var cursor = !cursorGezet && k < d.vol.length;
          if (cursor) cursorGezet = true;
          d.rest.classList.toggle('is-cursor', cursor);
          over -= k;
        });
      }
      var typend = zichtbaar && lokaal > 0 && lokaal < 1;
      if (zichtbaar !== s.zichtbaar) { s.zichtbaar = zichtbaar; s.el.classList.toggle('is-zichtbaar', zichtbaar); }
      if (typend !== s.typend) { s.typend = typend; s.el.classList.toggle('is-typend', typend); }
    }

    function zetKop(naam) {
      if (naam === staat.kop) return;
      staat.kop = naam;
      koppen.forEach(function (k) { k.classList.toggle('is-actief', k.dataset.kop === naam); });
    }

    function zetCta(o) {
      if (!cta || o === staat.cta) return;
      staat.cta = o;
      cta.style.opacity = o;
      cta.style.visibility = o > 0 ? 'visible' : 'hidden';
    }

    function zetPan(p) {
      if (!video) return;
      var x = null;
      if (mobielMq && mobielMq.matches) {
        x = Math.round((50 + (PAN_X - 50) * clamp((p - PAN_VAN) / (PAN_TOT - PAN_VAN), 0, 1)) * 2) / 2;
      }
      if (x === staat.pan) return;
      staat.pan = x;
      video.style.objectPosition = x === null ? '' : x + '% 50%';
    }

    function render(p) {
      staat.p = p;
      if (!(staat.rustig && heeftEindposter)) zoek(p * duur);

      zetPan(p);
      zetKop(p < KOP_MID ? 'start' : (p <= KOP_END ? 'mid' : 'end'));

      stappen.forEach(function (s, i) {
        var begin = STAP_BEGIN[i] !== undefined ? STAP_BEGIN[i] : 1;
        zetStap(s, clamp((p - begin) / TYPEN, 0, 1), p >= begin);
      });

      if (tdsEl) {
        var v = Math.round(tdsStart + (tdsEind - tdsStart) * clamp(p / TDS_EINDE, 0, 1));
        if (v !== staat.tds) { staat.tds = v; tdsEl.textContent = v; }
      }

      zetCta(Math.round(clamp((p - CTA_VAN) / (1 - CTA_VAN), 0, 1) * 1000) / 1000);
    }

    /* ---------- rustige stand ---------- */
    function toonRustig() {
      staat.rustig = true;
      render(1);
      if (!video) return;
      if (heeftEindposter) {
        video.hidden = true;
        video.preload = 'none';
      } else if (duur) {
        bezig = false;
        video.currentTime = Math.max(0, duur - 0.04);
      } else if (typeof bufferen === 'function') {
        bufferen();   // geen eindposter: metadata nodig voor het laatste frame
      }
    }

    /* ---------- aandrijving ----------
       Eén rAF-lus zolang de sectie in beeld is. De ruwe voortgang komt uit de
       rect van de sectie; de getoonde waarde loopt er met een lerp (0.12)
       naartoe. Er hangt dus geen werk aan het scroll-event zelf, en een
       veranderende paginahoogte (lazy beelden, apps) hoeft nergens gemeld te
       worden: de rect wordt elke frame opnieuw gelezen.

       Dit verving GSAP + ScrollTrigger (scrub 0.5). Die twee scripts kwamen van
       een externe CDN en stonden op de homepage in het kritieke pad. */
    var LERP = 0.12;
    var huidig = 0, inBeeld = false, lusActief = false;
    var rustigMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function voortgang() {
      var r = root.getBoundingClientRect();
      var lengte = r.height - window.innerHeight;
      if (lengte <= 0) return r.top <= 0 ? 1 : 0;
      return clamp(-r.top / lengte, 0, 1);
    }

    function lus() {
      if (!inBeeld || staat.rustig) { lusActief = false; return; }
      var doel = voortgang();
      huidig += (doel - huidig) * LERP;
      if (Math.abs(doel - huidig) < 0.0005) huidig = doel;
      render(huidig);
      requestAnimationFrame(lus);
    }

    function startLus() {
      if (lusActief || staat.rustig) return;
      lusActief = true;
      requestAnimationFrame(lus);
    }

    function zetRustig(aan) {
      if (aan) {
        inBeeld = false;
        toonRustig();
        return;
      }
      staat.rustig = false;
      if (video) video.hidden = false;
      huidig = voortgang();
      render(huidig);
      if (inBeeld) startLus();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (items) {
        inBeeld = items.some(function (i) { return i.isIntersecting; });
        if (inBeeld) startLus();
      }, { rootMargin: '100px 0px' }).observe(root);
    } else {
      inBeeld = true;
    }

    zetRustig(!!(rustigMq && rustigMq.matches));
    if (rustigMq) {
      var luister = rustigMq.addEventListener ? 'addEventListener' : 'addListener';
      rustigMq[luister]('change', function (e) { zetRustig(!!(e.matches !== undefined ? e.matches : rustigMq.matches)); });
    }

    root._ffGlas = {
      render: render, staat: staat, video: video,
      stop: function () { inBeeld = false; }
    };
  }

  function alles() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ff-glas]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ff-glas]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-ff-glas]');
    if (root && root._ffGlas) root._ffGlas.stop();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles, { once: true });
  } else {
    alles();
  }
})();
